import React from 'react';
import * as yup from "yup";
import {
    ClientSubType, ClientSubTypeQueryQuery,
    CostSupplierCategoriesQueryQuery,
    CostSupplierCategory, useClientSubTypeQueryQuery, useCostSupplierCategoriesMutationMutation,
    useCostSupplierCategoriesQueryQuery, useUpdateClientSubTypeMutation,
} from '../../generated/graphql';

import {ListEditor} from '../../components/list-editor';
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";

const schema =yup.array().of(
        yup.object().shape({
            'name': yup.string().required()
        }).required()
);

function blankClientSubType(): ClientSubType {
    return {
        id: uniqueId(),
        name: '',
    };
}

const columns = [{
    header: 'Name',
    accessor: 'name',
    dataType:'text',
}
];

function getValues(data:ClientSubTypeQueryQuery) {
    return data?.clientSubTypes?.data;
}


const ClientSubTypes = () => {
    const url = useLocation().pathname;
    const query = useClientSubTypeQueryQuery();
    const [mutation,mutationResult] = useUpdateClientSubTypeMutation();
    return (
        <ListEditor
            columns={columns}
            validationSchema={schema}
            title="Campaign Client Types"
            permission="campaignclienttypes"
            query={query}
            mutation={mutation}
            newRow={blankClientSubType}
            newRowLabel="Add Campaign Client Type"
            baseUrl={url}
            className="campaign-client-types"
            getValues={getValues}
            saveResult={mutationResult}
        />);
}
export default ClientSubTypes;